var map = {
	"./aboutIcon.png": 3217,
	"./acPowerIcon.png": 8437,
	"./batteryIcon.png": 5233,
	"./calculatorIcon.png": 7546,
	"./cameraIcon.png": 6347,
	"./cd.png": 1875,
	"./cdRomIcon.png": 6387,
	"./chartIcon.png": 3894,
	"./close.png": 5957,
	"./computerBig.png": 1114,
	"./computerSmall.png": 7253,
	"./consolePromptIcon.png": 6403,
	"./controlPanelFolderIcon.png": 9489,
	"./credits.png": 4995,
	"./dialupIcon.png": 6291,
	"./displayIcon.png": 564,
	"./doomIcon.png": 709,
	"./eurIcon.png": 1590,
	"./favoritesFolderIcon.png": 5769,
	"./floatingSphere.png": 3912,
	"./folderIcon.png": 3866,
	"./folderResumeIcon.png": 7343,
	"./forward.png": 2770,
	"./gamesFolderIcon.png": 9603,
	"./githubIcon.png": 8915,
	"./hardDriveIcon.png": 1403,
	"./ieBackIcon.png": 6573,
	"./ieForwardIcon.png": 4955,
	"./ieHomeIcon.png": 8113,
	"./ieIcon.png": 5592,
	"./ieRefreshIcon.png": 6541,
	"./ieStopIcon.png": 9184,
	"./internetExplorerIcon.png": 7968,
	"./jpegIcon.png": 7372,
	"./linkedinIcon.png": 5236,
	"./logOffIcon.png": 6599,
	"./mailIcon.png": 6907,
	"./maximize.png": 823,
	"./micropolisIcon.png": 1067,
	"./minesweeperIcon.png": 5640,
	"./minimize.png": 4825,
	"./ms-dead-face.png": 349,
	"./ms-flag.png": 6058,
	"./ms-minesweeper.png": 1680,
	"./ms-smiley-face.png": 8195,
	"./msDosIcon.png": 2400,
	"./msnChatIcon.png": 6762,
	"./msnIcon.png": 8024,
	"./msnNudgeIcon.png": 4501,
	"./myComputer.png": 1888,
	"./myComputerIcon.png": 431,
	"./not-configured-yet-icons/Dune2-desktop-icon.png": 305,
	"./not-configured-yet-icons/Jazz_Jackrabbit-app-icon.png": 6283,
	"./not-configured-yet-icons/worms-app-icon.png": 6398,
	"./notepadIcon.png": 53,
	"./obsidianIcon.png": 8157,
	"./offlineIcon.png": 7927,
	"./paintIcon.png": 3630,
	"./patchNotesIcon.png": 2735,
	"./pause.png": 7267,
	"./perceptionLabIcon.png": 4256,
	"./petGlitchIcon.png": 5538,
	"./petModemIcon.png": 9741,
	"./petPixelIcon.png": 8983,
	"./petStaticIcon.png": 9863,
	"./pinballIcon.png": 9716,
	"./pipesIcon.png": 5253,
	"./play.png": 3899,
	"./programsFolderIcon.png": 461,
	"./recycleBinEmptyIcon.png": 6423,
	"./recycleBinIcon.png": 6360,
	"./resetStorageIcon.png": 3110,
	"./resourceMeterIcon.png": 8977,
	"./resumeFileIcon.png": 9121,
	"./rewind.png": 292,
	"./runIcon.png": 4745,
	"./scrabbleIcon.png": 1754,
	"./scrollIcon.png": 2065,
	"./searchIcon.png": 1994,
	"./selectedWebsitesIcon.png": 8555,
	"./settingsIcon.png": 3133,
	"./showcaseIcon.png": 273,
	"./shutdownPcIcon.png": 1031,
	"./snakeIcon.png": 8138,
	"./solitaireIcon.png": 2038,
	"./soundRecorderIcon.png": 1653,
	"./sphere.png": 5794,
	"./stereogramIcon.png": 4551,
	"./stocksIcon.png": 4127,
	"./storeIcon.png": 6601,
	"./systemIcon.png": 2273,
	"./taskManagerIcon.png": 2182,
	"./televisionIcon.png": 6170,
	"./tetrisIcon.png": 6653,
	"./trailIcon.png": 4550,
	"./visitorCounterIcon.png": 4784,
	"./volumeOff.png": 3956,
	"./volumeOn.png": 5288,
	"./weatherCloudIcon.png": 205,
	"./weatherPartlyIcon.png": 9176,
	"./weatherRainIcon.png": 1308,
	"./weatherSnowIcon.png": 5079,
	"./weatherStormIcon.png": 3441,
	"./weatherSunIcon.png": 3776,
	"./winampIcon.png": 1266,
	"./windowExplorerIcon.png": 1731,
	"./windowGameIcon.png": 8032,
	"./windowResize.png": 3161,
	"./windowsStartIcon.png": 1927,
	"./zoteroIcon.png": 5159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5994;